import React from 'react';

export const TableGridPlaceholder: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      width="240"
      height="180"
      viewBox="0 0 240 180"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* First Row */}
      <rect
        x="10"
        y="10"
        width="50"
        height="40"
        rx="4"
        stroke="#E5E7EB"
        strokeWidth="2"
        strokeDasharray="4 4"
      />
      <rect
        x="70"
        y="10"
        width="50"
        height="40"
        rx="4"
        stroke="#E5E7EB"
        strokeWidth="2"
        strokeDasharray="4 4"
      />
      <rect
        x="130"
        y="10"
        width="50"
        height="40"
        rx="4"
        fill="#F3F4F6"
        stroke="#E5E7EB"
        strokeWidth="2"
      />
      <rect
        x="190"
        y="10"
        width="50"
        height="40"
        rx="4"
        stroke="#E5E7EB"
        strokeWidth="2"
        strokeDasharray="4 4"
      />

      {/* Second Row */}
      <rect
        x="10"
        y="60"
        width="50"
        height="40"
        rx="4"
        stroke="#E5E7EB"
        strokeWidth="2"
        strokeDasharray="4 4"
      />
      <rect
        x="70"
        y="60"
        width="50"
        height="40"
        rx="4"
        fill="#F3F4F6"
        stroke="#E5E7EB"
        strokeWidth="2"
      />
      <rect
        x="130"
        y="60"
        width="50"
        height="40"
        rx="4"
        stroke="#E5E7EB"
        strokeWidth="2"
        strokeDasharray="4 4"
      />
      <rect
        x="190"
        y="60"
        width="50"
        height="40"
        rx="4"
        fill="#F3F4F6"
        stroke="#E5E7EB"
        strokeWidth="2"
      />

      {/* Third Row */}
      <rect
        x="10"
        y="110"
        width="50"
        height="40"
        rx="4"
        stroke="#E5E7EB"
        strokeWidth="2"
        strokeDasharray="4 4"
      />
      <rect
        x="70"
        y="110"
        width="50"
        height="40"
        rx="4"
        stroke="#E5E7EB"
        strokeWidth="2"
        strokeDasharray="4 4"
      />
      <rect
        x="130"
        y="110"
        width="50"
        height="40"
        rx="4"
        stroke="#E5E7EB"
        strokeWidth="2"
        strokeDasharray="4 4"
      />
      <rect
        x="190"
        y="110"
        width="50"
        height="40"
        rx="4"
        stroke="#E5E7EB"
        strokeWidth="2"
        strokeDasharray="4 4"
      />
    </svg>
  );
};
